import axios from "axios";

export const SupportTiketService = {
  async getAll() {
    const response = await axios.get(
      `${process.env.REACT_APP_STRAPI_URL}/api/support-tikets`
    );

    const res = response.data.data;
    console.log("tikets:", res);

    const data = res.map((item) => ({
      id: item.id,
      manager: item.attributes.manager,
      message: item.attributes.message,
      supportId: item.attributes.supportId,
      createdAt: new Date(item.attributes.createdAt).toLocaleString(),
      updatedAt: new Date(item.attributes.updatedAt).toLocaleString(),
      publishedAt: new Date(item.attributes.publishedAt).toLocaleString(),
    }));

    return data;
  },

  async getFilterPopulate(id) {
    const response = await axios.get(
      `${process.env.REACT_APP_STRAPI_URL}/api/support-tikets?filters[supportId][id]=${id}`
    );

    const res = response.data.data;
    // console.log("tiketsFilterPopulate:", res);

    const data = res.map((item) => ({
      id: item.id,
      manager: item.attributes.manager,
      message: item.attributes.message,
      supportId: item.attributes.supportId,
      createdAt: new Date(item.attributes.createdAt).toLocaleString(),
      updatedAt: new Date(item.attributes.updatedAt).toLocaleString(),
      publishedAt: new Date(item.attributes.publishedAt).toLocaleString(),
    }));

    return data;
  },

  async getById(id) {
    const response = await axios.get(
      `${process.env.REACT_APP_STRAPI_URL}/api/support-tikets/${id}`
    );
    const res = response.data.data;
    // console.log("tikID", res);

    const data = {
      id: res.id,
      manager: res.attributes.manager,
      message: res.attributes.message,
      supportId: res.attributes.supportId,
      createdAt: new Date(res.attributes.createdAt).toLocaleString(),
      updatedAt: new Date(res.attributes.updatedAt).toLocaleString(),
      publishedAt: new Date(res.attributes.publishedAt).toLocaleString(),
    };

    return data;
  },

  async create(data, jwt) {
    const response = await axios.post(
      `${process.env.REACT_APP_STRAPI_URL}/api/support-tikets`,
      { data },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `bearer ${jwt}`,
        },
      }
    );

    return response.data;
  },

  async update(id, data, jwt) {
    const response = await axios.put(
      `${process.env.REACT_APP_STRAPI_URL}/api/support-tikets/${id}`,
      { data },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `bearer ${jwt}`,
        },
      }
    );

    return response.data;
  },

  async delete(id, jwt) {
    const response = await axios.delete(
      `${process.env.REACT_APP_STRAPI_URL}/api/support-tikets/${id}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `bearer ${jwt}`,
        },
      }
    );

    return response.data;
  },
};
